var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',{staticClass:"home-container"},[_c('el-aside',{attrs:{"width":_vm.isOpen ? '64px' : '200px'}},[_c('menus')],1),_c('el-main',[_c('right-main')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }